import { Image as SiteImage, OptionalSiteLinkWrapper, VideoPlayer } from 'components/shared';
import validateRequired from './validate-required';
import withPropValidation from './with-props-validation.tsx';

const Section = ({
  data: { backgroundImage, title, heroTitle, heroImage, description, link, vimeoUrl },
}) => (
  <OptionalSiteLinkWrapper link={link}>
    <div className="relative flex w-full flex-col antialiased md:h-screen md:max-h-[1000px] md:min-h-[700px] md:flex-row md:px-[15px] ">
      <div className="relative h-full min-h-[370px] w-full flex-1 overflow-hidden">
        {vimeoUrl ? (
          <VideoPlayer
            videoURL={vimeoUrl}
            className="h-full w-full"
            videoClassName="absolute min-h-[370px]"
          />
        ) : (
          <SiteImage src={backgroundImage} className="h-full w-full " />
        )}
      </div>
      <div className="flex-1">
        <div className="flex h-full flex-col items-center justify-between bg-blue text-center text-white">
          <h2 className="mt-[45px] mb-[34px] font-nimbus-sans-extd-d text-[12px] uppercase leading-[90%] md:mt-[58px] md:text-[16px]">
            {title?.split('<br>').map(line => (
              <span key={line}>
                {line}
                <br />
              </span>
            ))}
          </h2>
          <div>
            <h1 className="font-nimbus-sans-extd-d text-[35px] font-bold uppercase leading-[90%] md:text-[70px]">
              {heroTitle?.split('<br>').map(line => (
                <span key={line}>
                  {line}
                  <br />
                </span>
              ))}
            </h1>
            <SiteImage src={heroImage} layout="fixed" className="mt-1" />
            {link && (
              <div className="mt-9 font-nimbus-sans-extd-d text-[12px] uppercase underline">
                {link.text}
              </div>
            )}
          </div>
          <p className="mb-[45px] mt-[42px] max-w-[70%] font-nimbus-sans-d text-[15px] leading-[140%] md:mb-[58px]">
            {description}
          </p>
        </div>
      </div>
    </div>{' '}
  </OptionalSiteLinkWrapper>
);

export default withPropValidation(Section, ({ data: { name, title, description } }) =>
  validateRequired({
    Name: name,
    'Title / Description': title || description,
  })
);
